import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * 🔹 VIEW (lo que recibes del backend)
 */
export interface TipoVia {
  id?: number; // opcional en creación
  nombre: string;
  estado?: number; // opcional en creación
  fechaCreacion?: string; // lo devuelve el backend
  fechaModificacion?: string | null; // lo devuelve el backend
}

@Injectable({
  providedIn: "root",
})
export class TipoViaService {
  private apiUrl = `${environment.apiUrl}/api/tipo-via`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getTiposVia(): Observable<TipoVia[]> {
    return this.http
      .get<TipoVia[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getAllTipoViaActivos(): Observable<TipoVia[]> {
    return this.http
      .get<TipoVia[]>(`${this.apiUrl}/activos`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
  // Obtener por ID
  getTipoViaById(id: string | number): Observable<TipoVia> {
    return this.http
      .get<TipoVia>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Crear
  createTipoVia(payload: TipoVia): Observable<TipoVia> {
    return this.http
      .post<TipoVia>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Actualizar
  updateTipoVia(id: string | number, payload: TipoVia): Observable<TipoVia> {
    return this.http
      .put<TipoVia>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Eliminar
  deleteTipoVia(id: string | number): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Activar
  activar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Inactivar
  inactivar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}
